// extracted by mini-css-extract-plugin
export default {"overlay":"GameOverModal_overlay__KYnn4","modal":"GameOverModal_modal__sEkgN","modalText":"GameOverModal_modalText__nCe0i","modalButton":"GameOverModal_modalButton__kkHRm"};